//==============================================================================
// External dep.
//==============================================================================
const _ = require("lodash");
//------------------------------------------------------------------------------
// Interal dep.
//------------------------------------------------------------------------------
const channels = require("./app__channels").channels;

//------------------------------------------------------------------------------
// Packages
//------------------------------------------------------------------------------
const googlDisplay = _.find(channels, { channel_short_name: "google-display" });
const facebook = _.find(channels, { channel_short_name: "facebook" });
const instagram = _.find(channels, { channel_short_name: "instagram" });
const youtube = _.find(channels, { channel_short_name: "youtube" });
const twitter = _.find(channels, { channel_short_name: "twitter" });
const ebay = _.find(channels, { channel_short_name: "ebay-kleinanzeigen" });
const reddit = _.find(channels, { channel_short_name: "reddit" });

module.exports = [
  {
    budget: 500,
    minClicks: 250,
    name: "Social Media Booster S",
    id: "emplify--smb-500",
    nameShort: "S",
    description:
      "250 qualifizierte Klicks / 30 Tage Laufzeit. Kanäle: GDN, YouTube, Facebook, Instagram",
    color: "#B0D59D",
    selectedChannels: [googlDisplay, youtube, facebook, instagram]
  },
  {
    budget: 500,
    minClicks: 250,
    name: "Blue Collar Booster",
    id: "emplify--blue-collar-500",
    nameShort: "B",
    description:
      "250 qualifizierte Klicks / 30 Tage Laufzeit. Kanäle: YouTube, Facebook, Ebay Kleinanzeigen",
    color: "#b1eafb",
    selectedChannels: [ebay, youtube, facebook, instagram]
  },
  {
    budget: 500,
    minClicks: 150,
    name: "IT Booster",
    id: "emplify--it-booster-500",
    nameShort: "IT",
    description: "250 qualifizierte Klicks / 30 Tage Laufzeit. Kanäle: Twitter, Reddit, Facebook",
    color: "coral",
    selectedChannels: [twitter, reddit, facebook]
  }
];
